"use strict";

import {EventEmitter} from "events";

export default class Dispatcher extends EventEmitter {
	
	constructor() {
		super();
		this.setMaxListeners(Infinity);
	}
	
	dispatch(eventName, ...args) {
		return this.emit(eventName, ...args);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/flux/Dispatcher.js